import { render } from "./DecoresPage.vue?vue&type=template&id=689afcba"
import script from "./DecoresPage.vue?vue&type=script&lang=js"
export * from "./DecoresPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__